import {Component, ElementRef, OnInit} from '@angular/core';
import { MessageService } from './tab-message.service';
import { Constants } from '../Constant';
import { PublicService } from '../PublicService';
import sd from 'silly-datetime';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tab-message',
  templateUrl: './tab-message.page.html',
  styleUrls: ['./tab-message.page.scss'],
})
export class TabMessagePage implements OnInit {
  private msgData = [];
  private readonly nowDay;

  constructor(private readonly messageService: MessageService,
              public readonly router: Router,
              private readonly elementRef: ElementRef,
              private readonly publicService: PublicService) {
    this.nowDay = sd.format( new Date(), 'YYYY-MM-DD');
    this.publicService.event.on('message', () => {
      this.init();
    });
  }

  ngOnInit() {
    // this.init();
  }
  init(){
    this.messageService.loadMsgTypeCount().then(res => {
      if (res.code === Constants.SUCCESS){
        this.msgData = res.data;
      }else{
        this.publicService.presentToast(res.msg);
      }
    }, err => {
      this.publicService.checkNetworkToast(err);
    });
  }

  toMessageList(item){
      this.router.navigate(['/tabs/message/list'], {
          queryParams: {msgTypeName: item.msgTypeName, msgType: item.msgType}
      });
  }

  getTime(createTime){
    if (createTime){
      const day = createTime.substr(0, 10);
      const time = createTime.substr(11, 5);
      if (day === this.nowDay){
        return time;
      }else{
        return day;
      }
    }else{
      return createTime;
    }
  }
  getCount(count){
    count = Number(count);
    if (count > 99){
      return '99+';
    }else{
      return count;
    }
  }

}
